<template lang="pug">
  label.info-tooltip
    i.icon-error.fo.fo-exclamation(@click.stop="showErrorInfo = true")

    v-dialog(v-model="showErrorInfo" width="500")
      v-card.primary--text.py-4
        v-card-text.primary--text.pt-4
          h3 {{ title }}
          .pre-wrapper.mt-3(v-if="infoText" v-html="infoText")

        v-card-actions.d-flex.justify-center
          v-btn.btn-confirm-flat(color="secondary" large @click="showErrorInfo = false")
            span.primary--text Schließen

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class NErrorTooltip extends Vue {
  @Prop({ type: String, default: '' }) title
  @Prop({ type: String, default: '' }) infoText

  showErrorInfo = false
}
</script>

<style lang="scss">
.info-tooltip {
  display: inline-block;
  max-width: 18px;

  .icon-error {
    background-color: red;
    color: white;
    margin-right: 0;
    margin-bottom: 0;
  }
}

.pre-wrapper {
  white-space: pre-wrap;
}
</style>
